// extracted by mini-css-extract-plugin
export default {"hyphens":"uAkOf","container":"OdiCt","previewPhoto":"D1PaG","imageShare":"lur9e","projectImage":"O2jZd","imageWrapper":"t_NLa","textContainer":"ZFTTK","link":"OBjLf","title":"v9lkf"};